import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useSettings } from "@/context/SettingsContext";

export default function SearchBar({ suggestions = [], large = false }) {
  const { lang, t } = useLang();
  const { settings } = useSettings();
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const placeholder =
    settings.hero?.[`search_placeholder_${lang}`] || (lang === "fr" ? "Que recherchez-vous ?" : "What are you looking for?");

  const submit = (e) => {
    e.preventDefault();
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const applySuggestion = (s) => {
    navigate(`/search?q=${encodeURIComponent(s.query || s[`label_${lang}`])}`);
  };

  return (
    <div className="w-full">
      <form onSubmit={submit} data-testid="search-form" className="relative">
        <Search
          className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-anthracite/40"
          strokeWidth={1.5}
        />
        <input
          data-testid="search-input"
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={placeholder}
          className={`w-full border border-tertiary bg-white pl-14 pr-32 text-anthracite outline-none transition-all duration-300 placeholder:text-anthracite/40 focus:border-champagne focus:ring-1 focus:ring-champagne ${
            large ? "h-16 text-lg" : "h-14 text-base"
          }`}
        />
        <button
          type="submit"
          data-testid="search-submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 bg-anthracite px-6 py-2.5 text-sm font-medium text-ivory transition-colors duration-300 hover:bg-black"
        >
          {t("search_button")}
        </button>
      </form>

      {suggestions.length > 0 && (
        <div className="mt-4 flex flex-wrap items-center gap-2" data-testid="search-suggestions">
          <span className="text-xs uppercase tracking-[0.2em] text-anthracite/40">{t("search_examples")} :</span>
          {suggestions.map((s) => (
            <button
              key={s.id}
              data-testid={`suggestion-${s.id}`}
              onClick={() => applySuggestion(s)}
              className="rounded-full border border-tertiary bg-white px-3 py-1.5 text-xs text-anthracite/70 transition-colors duration-300 hover:border-champagne hover:text-champagne"
            >
              {s[`label_${lang}`]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
